import React from "react";

const CartIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="22.755" height="20" viewBox="0 0 22.755 20" fill={props.fill}><path d="M7.378 13.036h12.044a.663.663 0 0 0 .641-.473l2.667-9.125a.64.64 0 0 0-.108-.571.673.673 0 0 0-.533-.259h-16.25l-.477-2.097a.663.663 0 0 0-.651-.511h-4.044a.659.659 0 0 0-.667.652.659.659 0 0 0 .667.648h3.509l2.407 10.595a1.956 1.956 0 0 0-1.206 1.793 1.98 1.98 0 0 0 2 1.955h12.045a.652.652 0 1 0 0-1.3h-12.044a.652.652 0 1 1 0-1.3zm0 0"/><path d="M151 362.183a2.179 2.179 0 1 0 2.179-2.183 2.181 2.181 0 0 0-2.179 2.183zm0 0" transform="translate(-144.417 -344.361)"/><path d="M362 362.183a2.179 2.179 0 1 0 2.183-2.183 2.181 2.181 0 0 0-2.183 2.183zm0 0" transform="translate(-346.51 -344.361)"/></svg>
    )
}

export default CartIcon;
